import { useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";

export default function AuthCallback() {
  const { googleSession } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const processed = useRef(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;
    const sessionId = new URLSearchParams(location.hash.replace(/^#/, "")).get("session_id");
    const target = location.pathname === "/" ? "/account" : location.pathname;
    googleSession(sessionId)
      .then(() => { window.history.replaceState(null, "", target); navigate(target, { replace: true }); })
      .catch(() => navigate("/login", { replace: true }));
  }, [googleSession, location, navigate]);

  return <div className="flex min-h-[60vh] items-center justify-center text-sm text-muted-foreground" data-testid="auth-callback">Signing you in…</div>;
}
